import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { forkJoin, take } from 'rxjs';
import { ApiKeySupplierMetadata, Customer } from '../../../../model/models';
import { CustomersService } from '../../../../services/customers/customers.service';

@Component({
  selector: 'supplier-metadata-editor',
  standalone: true,
  imports: [CommonModule, FormsModule, NzButtonModule, NzIconModule, NzSelectModule, NzSkeletonModule],
  templateUrl: './supplier-metadata-editor.component.html',
  styleUrl: './supplier-metadata-editor.component.scss'
})
export class SupplierMetadataEditorComponent implements OnInit {
  @Input({ required: true }) customer!: Customer
  @Input({ required: true }) entries!: ApiKeySupplierMetadata[]
  @Output() entriesChange = new EventEmitter<ApiKeySupplierMetadata[]>()

  customersService = inject(CustomersService)

  supplierSystems: any[] = []
  locations: any[] = []
  isLoading = true

  ngOnInit(): void {
    forkJoin({
      supplierSystems: this.customersService.getSupplierSystems(this.customer.pk).pipe(take(1)),
      locations: this.customersService.getCustomerLocations(this.customer.pk).pipe(take(1))
    }).subscribe(({ supplierSystems, locations }) => {
      this.supplierSystems = supplierSystems
      this.locations = locations
      this.isLoading = false
    })
  }

  addRow(): void {
    this.entries = [...this.entries, { supplier_system_partner_id: '', supplier_partner_id: '' }]
    this.entriesChange.emit(this.entries)
  }

  removeRow(index: number): void {
    this.entries = this.entries.filter((_, i) => i !== index)
    this.entriesChange.emit(this.entries)
  }

  updateRow(index: number, field: keyof ApiKeySupplierMetadata, value: string): void {
    this.entries = this.entries.map((entry, i) => i === index ? { ...entry, [field]: value } : entry)
    this.entriesChange.emit(this.entries)
  }
}
